import styled from 'styled-components';

const A = styled.a`
  color: #000;

  &:hover {
    color: #000;
  }
`;

export default A;
